module.exports = __webpack_public_path__ + "img/logo_light.feebfbab.png";